import { connect } from 'react-redux';
import { ratingChange } from './actions';
import { questionKey } from '../response/reducer';
import PureRatingIcon from './PureRatingIcon';

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];
  return {
    curVal: +question.value,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onClick: () => dispatch(ratingChange(ownProps.value, ownProps.questionId)),
});

const RatingIcon = connect(mapStateToProps, mapDispatchToProps)(PureRatingIcon);

export default RatingIcon;
